import { UIHeading1, UIHeading2, UIHeading3, UIHeading4, UIHeading5, UIHeading6 } from '@cian/ui-kit';
import { COMMON_COMPONENT_PROPS } from '../const';

export const uiHeadings = {
  UIHeading1: {
    ...COMMON_COMPONENT_PROPS,
    id: 'uiHeading1',
    component: UIHeading1,
    tagName: 'uiheading1',
    block: {
      label: 'UIHeading1',
      category: 'Typography',
      content: '<UIHeading1>UIHeading1</UIHeading1>',
    },
  },

  UIHeading2: {
    ...COMMON_COMPONENT_PROPS,
    id: 'uiHeading2',
    component: UIHeading2,
    tagName: 'uiheading2',
    block: {
      label: 'UIHeading2',
      category: 'Typography',
      content: '<UIHeading2>UIHeading2</UIHeading2>',
    },
  },

  UIHeading3: {
    ...COMMON_COMPONENT_PROPS,
    id: 'uiHeading3',
    component: UIHeading3,
    tagName: 'uiheading3',
    block: {
      label: 'UIHeading3',
      category: 'Typography',
      content: '<UIHeading3>UIHeading3</UIHeading3>',
    },
  },

  UIHeading4: {
    ...COMMON_COMPONENT_PROPS,
    id: 'uiHeading4',
    component: UIHeading4,
    tagName: 'uiheading4',
    block: {
      label: 'UIHeading4',
      category: 'Typography',
      content: '<UIHeading4>UIHeading4</UIHeading4>',
    },
  },

  UIHeading5: {
    ...COMMON_COMPONENT_PROPS,
    id: 'uiHeading5',
    component: UIHeading5,
    tagName: 'uiheading5',
    block: {
      label: 'UIHeading5',
      category: 'Typography',
      content: '<UIHeading5>UIHeading5</UIHeading5>',
    },
  },

  UIHeading6: {
    ...COMMON_COMPONENT_PROPS,
    id: 'uiHeading6',
    component: UIHeading6,
    tagName: 'uiheading6',
    block: {
      label: 'UIHeading6',
      category: 'Typography',
      content: '<UIHeading6>UIHeading6</UIHeading6>',
    },
  },
};
